import React from "react";
import { Link, Outlet } from 'react-router-dom';
import "../../App.scss";
import "../../index.css"
import { Col, ConfigProvider, Image, Layout, Row } from 'antd';
import { frontendurls } from "../../constants/FrontendURLs";
import logo from "../../logo.svg";

const SecondLayouts = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#eb8a14",
          colorInfo: "#eb8a14",
        },
      }}
    >
      <Layout className="min-h-screen">
        <Row className="min-h-screen bg-gradient-to-b from-[#121212] to-[#3c261c]">
          <Col
            xs={24}
            md={14}
            className="bg-white rounded-none md:rounded-r-2xl"
          >
            <div className="grid min-h-screen">
              <div className="imagebank-header px-4 sm:px-10 pt-6 pb-2 w-fit h-auto">
                <Link to={frontendurls.Home}>
                  <Image
                    src={logo}
                    alt="Plural Publishing Image Bank"
                    preview={false}
                    width={120}
                  />
                </Link>
              </div>
              <Outlet />
              <div className="text-gray-400 self-end px-4 sm:px-10  py-6 text-xs bg-transparent">
                © {new Date().getFullYear()} Plural Publishing, Inc.
              </div>
            </div>
          </Col>
          <Col xs={24} md={10} className="hidden md:block ">
            <div className="bg-gray-500 h-full w-1/2 fixed top-0 register-background"></div>
          </Col>
        </Row>
      </Layout>
    </ConfigProvider>
  );
};
export default SecondLayouts;
